import { Component, OnInit } from '@angular/core';
///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
@Component({
  selector: 'app-referencia',
  templateUrl: './referencia.component.html',
  styleUrls: ['./referencia.component.scss']
})
export class ReferenciaComponent implements OnInit {

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
   }
  

  ngOnInit() {
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
  }
  idiomaBanner:any;

  cambiaIdiomaBanner(idioma:string){
    this.idiomaBanner = this.translateSrv.currentLang; 
    switch(idioma){
      case 'es': this.idiomaBanner = idioma; 
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }
  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-03.png';
  }

}
